import React from "react"
import {
  results,
  resultsContainer,
  resultItem,
  resultDetails,
  resultMore,
  resultTitle,
  resultTitleNotClickable,
  resultTop,
  resultItemTaxo,
  resultItemTaxoContainer,
} from "./adress-search-results.module.scss"
import PropTypes from "prop-types"
import { Article } from "../ResultsTaxo/ResultItem/result-item-styled"
import TransitionFade from "../transition-fade"
import { AdressItemTaxo } from "../../templates/list/listItems/styled-components/adresse-item-styled"
import { StyledAdresseItem } from "../../templates/list/styled-components/adresses-styled"

//-----------------------Parent component---------------------------//

const AdressSearchResults = ({
  resultats,
  changeAdress,
  choosenAdress,
  adresses,
  choosenTaxo,
  initialAdress,
}) => {
  let finalResult = []
  return (
    <section className={results}>
      <ul className={resultsContainer}>
        {resultats.map((result) => {
          adresses.map(({ node }) => {
            if (node.title === result.title) {
              if (choosenTaxo !== null && choosenTaxo !== undefined) {
                finalResult.push(Object.assign(result, node))
                finalResult = finalResult.filter((element) => {
                  for (
                    let cpt = 0;
                    cpt <
                    element.relationships.field_taxonomie_thematique.length;
                    cpt++
                  ) {
                    if (Array.isArray(choosenTaxo)) {
                      if (
                        choosenTaxo.includes(
                          element.relationships.field_taxonomie_thematique[cpt]
                            .name
                        )
                      ) {
                        return true
                      }
                    } else if (
                      element.relationships.field_taxonomie_thematique[cpt]
                        .name === choosenTaxo
                    ) {
                      return true
                    }
                  }
                  return null
                })
              } else if (choosenTaxo === undefined) {
                finalResult.push(Object.assign(result, node))
              }
            }
            return null
          })
          return null
        })}
        {finalResult.map((finalResultat) => (
          <Result
            changeAdress={changeAdress}
            choosenAdress={choosenAdress}
            key={finalResultat.url}
            result={finalResultat}
            initialAdress={initialAdress}
          />
        ))}
      </ul>
    </section>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Result = ({ result, changeAdress, choosenAdress, initialAdress }) => {
  let active
  if (
    choosenAdress !== null &&
    choosenAdress.field_coordon?.lat === result.field_coordon?.lat &&
    choosenAdress.field_coordon?.lon === result.field_coordon?.lon
  ) {
    active = true
  } else {
    active = false
  }
  return (
    <StyledAdresseItem
      active={active}
      clickable={!!result.field_coordon && !active}
      key={result.drupal_id}
    >
      <Article className={resultItem}>
        <div className={resultTop}>
          <p
            role="button"
            tabIndex={0}
            onClick={() => {
              if (result.field_coordon) {
                changeAdress(result, choosenAdress, result.title, initialAdress)
              }
            }}
            onKeyDown={() => {
              if (event.key === "Enter") {
                if (result.field_coordon) {
                  changeAdress(
                    result,
                    choosenAdress,
                    result.title,
                    initialAdress
                  )
                }
              }
            }}
            className={
              result.field_coordon && !active
                ? resultTitle
                : resultTitleNotClickable
            }
          >
            {result.title}
          </p>
          <TransitionFade className={resultMore} link={result.path.alias}>
            Plus d&apos;infos
          </TransitionFade>
        </div>
        <div className={resultDetails}>
          <div className={resultItemTaxoContainer}>
            {result.relationships.field_taxonomie_thematique
              ?.slice(0, 3)
              .map((element, index) => (
                <AdressItemTaxo key={index} className={resultItemTaxo}>
                  {element.name}
                </AdressItemTaxo>
              ))}
          </div>
        </div>
      </Article>
    </StyledAdresseItem>
  )
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

AdressSearchResults.propTypes = {
  resultats: PropTypes.array.isRequired,
  changeAdress: PropTypes.func,
  choosenAdress: PropTypes.object,
  adresses: PropTypes.object,
  choosenTaxo: PropTypes.string,
  initialAdress: PropTypes.object,
}
Result.propTypes = {
  result: PropTypes.object.isRequired,
  changeAdress: PropTypes.func,
  choosenAdress: PropTypes.object,
  initialAdress: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default AdressSearchResults
